{
  "version": 1,
  "asset_id": "1fc97291-295c-48e2-ac7d-50bcd3518199",
  "project_id": "9f205a2e-8c62-436c-9ba0-eb8567773752",
  "url": "/__l5e/assets-v1/1fc97291-295c-48e2-ac7d-50bcd3518199/how-it-works-hero-1600.avif",
  "r2_key": "a/v1/9f205a2e-8c62-436c-9ba0-eb8567773752/1fc97291-295c-48e2-ac7d-50bcd3518199/how-it-works-hero-1600.avif",
  "original_filename": "how-it-works-hero-1600.avif",
  "size": 86989,
  "content_type": "image/avif",
  "created_at": "2026-07-22T22:51:55Z"
}
